export default from './SideBar';



// WEBPACK FOOTER //
// ./src/sharedComponents/MobileNonAuthHeader/components/SideBar/index.js